<template>
    <div class="header">
        <!-- <div class="header-top">
					<ul class="wrapper">
						<li>门户</li>
						<li>学生</li>
						<li>教职工</li>
						<li>邮箱</li>
						<li>领导信箱</li>
					</ul>
				</div> -->
        <div class="header-bottom">
            <div class="wrapper" style="display: flex;justify-content: space-between;align-items: center;">
                <div class="logo">
                    <a href="/"><img src="/image/logo.png" alt="" /></a>
                </div>
                <div class="list" style="width:74%" >
                    <ul>
                        <li class="yiji-li" v-for="(item,index) in List" :key="item.id">
                            <a :class="{ 'active': headerNew === index }" v-bind:href="`${item.link}?title=${item.title}`"
                                title="学校概况">
                                <em>{{ item.title }}</em>
                            </a>
                            <div class="erji-ul" v-if="item.lists[0].id != null">
                                <dl>
                                    <dd v-for="item1 in item.lists" :key="item1.id">
                                        <a :href="`${item1.link}?title=${item1.title}`">
                                            {{ item1.title }}
                                        </a>
                                    </dd>
                                </dl>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="media-list">
                    <img src="/image/list.png" alt="" @click="toggleNavList" />
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="media-list-ul" v-if="showMediaList">
                <ul>
                    <li v-for="item in List" :key="item.id">
                        <a :href="`${item.link}?title=${item.title}`" title="学校概况">{{ item.title }}</a>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    name: 'headerList',
    props: {
        navData: {
            type: Array,
            default: false
        },
    },
    computed: {
        ...mapState(['headerNew'])
    },
    data() {
        return {
            List: this.navData,
            isNone: false,
            showMediaList: false
        }
    },
    watch: {
        navData(newValue) {
            this.List = newValue
        }
    },
    methods: {
        toggleNavList() {
            this.showMediaList = !this.showMediaList;
        },
    }
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.8s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0;
}
.header-bottom .logo{margin-top: 0px;}
.header-bottom .logo img{
    width: 3.5rem;
    height: 1rem;
}
</style>